var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAscendingLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "901px",
    height: "901px",
    viewBox: "0 0 901 901",
    style: {
      enableBackground: "new 0 0 931 931"
    },
    xmlSpace: "preserve",
    fill: "none",
    stroke: "#161615",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M900.5,851c0-27.6-22.4-50-50-50h-750V50c0-27.6-22.4-50-50-50c-27.6,0-50,22.4-50,50v751c0,55.1,44.9,100,100,100h750 C878.1,901,900.5,878.6,900.5,851z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.3,416.7L149,649.1c-8.5,10.9-6.5,26.601,4.4,35.101l39.5,30.7c10.9,8.5,26.6,6.5,35.1-4.4l153.899-198.3 c8.4-10.9,21-17.8,34.7-19.101l170.3-16.5c13.2-1.3,25.4-7.699,33.801-18l174.6-212.2l42,34.8c16,13.2,40.2,2.4,40.9-18.4 l6.1-170.7c0.6-16.1-14.1-28.6-29.9-25.4L683.7,101.1c-20.601,4.1-27.2,30.3-11,43.8l45.6,37.8L569.7,363 c-8.4,10.2-20.601,16.7-33.801,18l-172,16.6C350.3,399,337.7,405.9,329.3,416.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingLine);
export default __webpack_public_path__ + "static/media/ascendingLine.2aec1b4e.svg";
export { ForwardRef as ReactComponent };